import React, { useEffect, useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import DefinitionAndClaimComponent from "./DefinitionAndClaimContent";
import ColumnDictionary from "./ColumnDictionaryContent";
import Filter from "./filter";
import GTM from "../../GTM";
import PropTypes from "prop-types";
function DefinitionContent(props) {
    const {
        showDefinitionContent,
        selectedDefinitionContent,
        handleBack,
        backDrop,
        setShowDefinitionContent,
        handleHelpClose,
    } = props?.helpSectionProps || {};
    const [filterValue, setFilterValue] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [animationClass, setAnimationClass] = useState("slide-in");
    const gtm = new GTM(null);
    const filteredPadding =
        filteredData?.length > 5 ? "0px 0px 0px 32px" : "0px 28px";
    const contentPadding =
        selectedDefinitionContent?.Content?.length > 0
            ? "0px 0px 0px 32px"
            : "0px 32px";

    const handleClose = () => {
        setAnimationClass("slide-out");
        handleHelpClose();
    };

    const handleBackHelp = () => {
        setAnimationClass("slide-out");
        setTimeout(() => {
            setShowDefinitionContent(false);
            handleBack();
        }, 1100);
    };

    // Keydown event handler for scrolling
    const handleKeyDown = (event) => {
        const modalBody = document.querySelector(".modal-body");
        if (modalBody) {
            if (event.key === "ArrowDown") {
                event.preventDefault();
                modalBody.scrollBy({ top: 1, behavior: "smooth" });
            } else if (event.key === "ArrowUp") {
                event.preventDefault();
                modalBody.scrollBy({ top: -1, behavior: "smooth" });
            }
        }
    };

    useEffect(() => {
        if (showDefinitionContent) {
            window.addEventListener("keydown", handleKeyDown);
        }
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [showDefinitionContent]);

    useEffect(() => {
        if (filterValue !== null && filterValue !== "") {
            const filtered = selectedDefinitionContent?.Content.filter(
                (item) =>
                    item["Column Name"]
                        .toLowerCase()
                        .startsWith(filterValue.trim().toLowerCase()) // Match the starting part
            );

            const sorted = filtered.sort((a, b) =>
                (a["Column Name"] || "").localeCompare(
                    b["Column Name"] || "",
                    undefined,
                    { sensitivity: "base" }
                )
            );

            setFilteredData(
                sorted.map((item, index) => ({
                    ...item,
                    id: index + 1, // Adding an ID based on the index of the filtered items
                }))
            );
        } else {
            const sorted = selectedDefinitionContent?.Content
                ? [...selectedDefinitionContent.Content].sort((a, b) =>
                      (a["Column Name"] || "").localeCompare(
                          b["Column Name"] || "",
                          undefined,
                          { sensitivity: "base" }
                      )
                  )
                : [];

            setFilteredData(
                sorted.map((item, index) => ({
                    ...item,
                    id: index + 1, // Adding an ID based on the index of the items if no filter is applied
                }))
            );
        }
    }, [filterValue, selectedDefinitionContent]);

    const handleFilterChange = useCallback((e) => {
        e.preventDefault();
        const newValue = e.target.value;
        setFilterValue(newValue);
    }, []);

    const handleClearSearch = useCallback(() => {
        setFilterValue("");
    }, []);

    const filteronblur = (e) => {
        //GTM Event
        if (e.target.value !== "") {
            gtm.Event(
                "help",
                "textbox",
                "interact",
                "filter",
                "report detail",
                `${selectedDefinitionContent.Name}`,
                "field_interaction",
                "undefined"
            );
        }
    };

    return (
        <Modal
            show={setShowDefinitionContent}
            dialogClassName="claim-diagnostic-section"
            size="xl"
            backdrop="true"
            onHide={handleClose}
            className={animationClass}
            backdropClassName={
                backDrop ? "helpSection-backdrop" : "helpContent-backdrop"
            }
        >
            <Modal.Header style={{ justifyContent: "space-between" }}>
                <button
                    className="help-buttons align-items-center border-0 bg-transparent"
                    style={{ fontWeight: 700 }}
                    onClick={handleBackHelp}
                >
                    <i className="fa-solid fa-angle-left"></i> Back
                </button>
                <button
                    className="help-buttons align-items-center border-0 bg-transparent"
                    style={{ paddingRight: 0 }}
                    onClick={handleClose}
                >
                    <i className="fa-solid fa-xmark"></i> Close
                </button>
            </Modal.Header>
            <div
                className={`${
                    selectedDefinitionContent.ContentType === "columnDetails"
                        ? "Definitionheader"
                        : "header"
                }`}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <div>{selectedDefinitionContent.Name}</div>
                {selectedDefinitionContent.ContentType === "columnDetails" && (
                    <button
                        className="ml-2p text-primary-main cursor-pointer border-0 position-relative"
                        tabIndex={0}
                    >
                        <Filter
                            filterValue={filterValue}
                            handleFilterChange={handleFilterChange}
                            filteronblur={filteronblur}
                            handleClearSearch={handleClearSearch}
                        />
                    </button>
                )}
            </div>

            {selectedDefinitionContent.ContentType === "columnDetails" && (
                <p
                    className="fs"
                    style={{ padding: "0px 32px", marginBottom: "10px" }}
                >
                    These definitions apply to all reports
                </p>
            )}

            <Modal.Body
                style={{
                    padding:
                        selectedDefinitionContent?.Content?.length > 0 &&
                        filteredData?.length > 5
                            ? contentPadding
                            : filteredPadding,
                }}
            >
                <div
                    className="modalBodySection"
                    style={{
                        maxHeight: "calc(100vh - 195px)",
                        overflowY: "auto",
                        height: 1000,
                        boxSizing: "content-box",
                    }}
                >
                    <div
                        className="pr-32p card-section"
                        style={{
                            boxSizing: "border-box",
                        }}
                    >
                        <div style={{ width: "610px" }}>
                            {selectedDefinitionContent.ContentType ===
                            "columnDetails" ? (
                                <ColumnDictionary content={filteredData} />
                            ) : (
                                <DefinitionAndClaimComponent
                                    content={selectedDefinitionContent}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

DefinitionContent.propTypes = {
    helpSectionProps: PropTypes.shape({
        showDefinitionContent: PropTypes.bool,
        selectedDefinitionContent: PropTypes.shape({
            Name: PropTypes.string,
            Content: PropTypes.arrayOf(
                PropTypes.shape({
                    Definition: PropTypes.string,
                    Code: PropTypes.string,
                    Example: PropTypes.string,
                })
            ),
            IconHtml: PropTypes.string,
            Order: PropTypes.number,
            ContentType: PropTypes.string,
        }),
        handleBack: PropTypes.func,
        backDrop: PropTypes.bool,
        setShowDefinitionContent: PropTypes.func,
        handleHelpClose: PropTypes.func,
    }),
};

export default DefinitionContent;
